import React from "react"
import Layout from "../components/Layout/Layout"
import styled from "styled-components"

import SpaceContent1 from "../components/space/space1"

const Container = styled.div`
  overflow-x: hidden;
`
const spacePage = () => {
  return (
    <Container>
      <Layout>
        <SpaceContent1 />
      </Layout>
    </Container>
  )
}

export default spacePage
